import { render, staticRenderFns } from "./codeBlock.vue?vue&type=template&id=4c8a4d8c&scoped=true&"
import script from "./codeBlock.vue?vue&type=script&lang=js&"
export * from "./codeBlock.vue?vue&type=script&lang=js&"
import style0 from "./codeBlock.vue?vue&type=style&index=0&id=4c8a4d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8a4d8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c8a4d8c')) {
      api.createRecord('4c8a4d8c', component.options)
    } else {
      api.reload('4c8a4d8c', component.options)
    }
    module.hot.accept("./codeBlock.vue?vue&type=template&id=4c8a4d8c&scoped=true&", function () {
      api.rerender('4c8a4d8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/codeBlock.vue"
export default component.exports